import React, { useState } from 'react'
import Navbar from '../Navbar'
import { MDBContainer, MDBRow, MDBCol, MDBIcon, MDBBtn } from 'mdbreact'
import FooterWhite from '../FooterWhite'
// import { HashLink as Link } from 'react-router-hash-link';
import contactDoodle from '../../img/contactDoodle.png'
import TreeCounter from '../TreeCounter'
import SearchModal from './SearchModal'

const Contact = () => {
    const [show, setShow] = useState(false);

    return (
        <>
        <Navbar show={show} onClick={()=>setShow(!show)} page="Contact Us"/>
        <div style={{ display: show ? "none" : "inline" }} className="contact-wrapper">
        <TreeCounter/>
        <MDBContainer id="contact-us" className="py-5 my-5">
            <h1 className="font-weight-bold h1-responsive">Send us a message</h1>
            <p className="mb-5 lead">Need help with something? Do reach out to us.</p>
            <MDBRow>
                <MDBCol md="8" lg="8">
                    <form action="https://formspree.io/mbjzbbep" method="POST">
                        <input name="name" type="text" required className="form-control form-control-lg input-custom mb-4" placeholder="Your Name" />
                        <input name="_replyto" type="email" required className="form-control form-control-lg input-custom my-4" placeholder="Your Email" />
                        <input name="subject" type="text" required className="form-control form-control-lg input-custom my-4" placeholder="Your Subject" />
                        <textarea name="message" rows="5" required type="text" className="form-control form-control-lg input-custom my-4" placeholder="Your Message" />
                        <MDBBtn type="submit" color="dark" className="mx-0 my-0 my-lg-4 my-md-4 text-capitalize">Send Message <MDBIcon fas icon="arrow-right ml-2"/></MDBBtn>
                    </form>
                </MDBCol>
                <MDBCol md="4" lg="4">
                    <img src={contactDoodle} alt="" className="w-100 my-5"/>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
        <MDBContainer fluid className="px-0 grey lighten-4 mt-5">
            <section className="p-5 grey lighten-4">
                <MDBRow className="py-5 justify-content-center">
                    <MDBCol md="10" lg="8">
                        <div className="text-center">
                            <h2 style={{ lineHeight: 1.5 }} className="font-weight-bold h2-responsive">
                                Got more questions?
                            </h2>
                            <p className="lead">
                                More questions about what we do, our products,
                                our founder, and everything you need to know 
                                about Minimuni. Personal and Business questions
                                are encouraged.
                            </p>
                            <a href="mailto:wilcaoconer@theminimuni.com">
                                <MDBBtn color="dark" className="text-capitalize">
                                    Send Inquiry <MDBIcon fas icon="arrow-right ml-2"/>
                                </MDBBtn>
                            </a>
                        </div>
                    </MDBCol>
                </MDBRow>
            </section>
        </MDBContainer>
        <FooterWhite/>
        </div>
        <SearchModal onClick={()=>setShow(false)} show={show}/>
        </>
    )
}

export default Contact
